import React from 'react';

import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import ExportData from '../../../../layout/layoutHeader/components/ExportData';
import FullScreen from '../../../../layout/layoutHeader/components/FullScreen';
import ShowHideColumns from '../../../../layout/layoutHeader/showHideColumns';
import { withUserProfile } from '../../../../userProfile/userProfileContext';
import SearchBox from '../../../common/SearchBox';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    height: 32,
    padding: '8 0',
    color: theme.TextColor
  },
  title: {
    display: 'flex',
    padding: '8 24'
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  showHideColumns:{
    padding: 10,
    borderLeft:`1px solid ${theme.AppBGColor}`
  }
});

const GridHeader = ({ classes, title, onSearchText, gridApi, userData ,onMaximize, exportFileName}) => {
  return (
    <header className={classes.container}>
      <span className={classes.title}>{title}</span>
      <div className={classes.actionContainer}>
        <SearchBox onChange={onSearchText} />
        <ClearAllFilterButton gridApi={gridApi} />
        <div className={classes.showHideColumns}>
          <ShowHideColumns api={gridApi} userData={userData} />
        </div>

        <ExportData gridApi={gridApi} userData={userData} name={exportFileName} />
        <FullScreen toggleFullscreen={onMaximize} />
      </div>
    </header>
  );
};

export default compose(withStyles(styles), withUserProfile)(GridHeader);
